import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "./base.service";

@Injectable({providedIn: 'root'})
export class ClientesService2 extends BaseService {
  private baseUrl: string = "";

  constructor(private http: HttpClient, configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  private authorizedHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    const authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  possuiImportantesInfos(params: { clientes: number[] }) {
    const headers = this.authorizedHeaders();

    return this.http
      .post<number[]>(
        `${this.baseUrl}/clients/possuiImportantesInfos`,
        params,
        {
          headers,
        }
      )
      .catch(this.handleError);
  }

}
